import script from "./editClockIn.vue?vue&type=script&setup=true&lang=js"
export * from "./editClockIn.vue?vue&type=script&setup=true&lang=js"

import "./editClockIn.vue?vue&type=style&index=0&id=2c0a96ba&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0a96ba"]])

export default __exports__